import http from 'plugins/axios';

export default {
  types() {
    return http.get({ url: '/ta/admin/tenant/public-subject/types' });
  },

  page({ page = 1, size = 20, side, userType, startTime, endTime } = {}) {
    let url = `/ta/admin/tenant/public-subject/transfer/page?page=${page}&size=${size}`;
    if (side) url += `&side=${side}`;
    if (userType != null && userType !== '') url += `&userType=${userType}`;
    if (startTime != null && startTime !== '') url += `&startTime=${startTime}`;
    if (endTime != null && endTime !== '') url += `&endTime=${endTime}`;
    return http.get({ url });
  },

  accounts() {
    return http.get({ url: '/ta/admin/tenant/public-subject/transfer/accounts' });
  },

  allowedTo(fromUserType) {
    return http.get({
      url: `/ta/admin/tenant/public-subject/transfer/allowed-to?fromUserType=${fromUserType}`,
    });
  },

  coins({ fromUserType, toUserType }) {
    let url = '/ta/admin/tenant/public-subject/transfer/coins';
    if (fromUserType != null) url += `?fromUserType=${fromUserType}`;
    if (toUserType != null) {
      url += fromUserType != null ? `&toUserType=${toUserType}` : `?toUserType=${toUserType}`;
    }
    return http.get({ url });
  },

  create({ fromUserType, toUserType, coin, amount }) {
    return http.post({
      url: '/ta/admin/tenant/public-subject/transfer/create',
      data: { fromUserType, toUserType, coin, amount },
    });
  },
};
